import React from "react";
import { v4 } from "uuid";
import { withTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";

import { List } from "tabler-react";
import HasPermissionWrapper from "../../../HasPermissionWrapper";
import { GET_SHOP_FEATURES_QUERY } from "./waitlist/queries";

const ClassEditMenu = ({ t, activeLink, classId }) => {
    const { data: shopFeaturesData } = useQuery(GET_SHOP_FEATURES_QUERY);
    const waitlistEnabled =
        shopFeaturesData?.systemFeatureShop?.waitlist || false;

    return (
        <List.Group transparent={true}>
            <List.GroupItem
                key={v4()}
                className="d-flex align-items-center"
                to={"#/schedule/classes/all/edit/" + classId}
                icon="edit-3"
                active={activeLink === "edit"}
            >
                {t("general.edit")}
            </List.GroupItem>
            <HasPermissionWrapper
                resource="scheduleitemaccount"
                permission="view"
            >
                <List.GroupItem
                    key={v4()}
                    className="d-flex align-items-center"
                    to={"#/schedule/classes/all/instructors/" + classId}
                    icon="users"
                    active={activeLink === "instructors"}
                >
                    {t("general.instructors")}
                </List.GroupItem>
            </HasPermissionWrapper>
            <HasPermissionWrapper
                resource="scheduleitemenrollment"
                permission="view"
            >
                <List.GroupItem
                    key={v4()}
                    className="d-flex align-items-center"
                    to={"#/schedule/classes/all/enrollments/" + classId}
                    icon="check-square"
                    active={activeLink === "enrollments"}
                >
                    {t("general.enrollments")}
                </List.GroupItem>
            </HasPermissionWrapper>
            <HasPermissionWrapper
                resource="scheduleitemprice"
                permission="view"
            >
                <List.GroupItem
                    key={v4()}
                    className="d-flex align-items-center"
                    to={"#/schedule/classes/all/prices/" + classId}
                    icon="copy"
                    active={activeLink === "prices"}
                >
                    {t("schedule.classes.prices.title")}
                </List.GroupItem>
            </HasPermissionWrapper>
            <HasPermissionWrapper
                resource="scheduleitemorganizationsubscriptiongroup"
                permission="view"
            >
                <List.GroupItem
                    key={v4()}
                    className="d-flex align-items-center"
                    to={"#/schedule/classes/all/subscriptions/" + classId}
                    icon="edit"
                    active={activeLink === "subscriptions"}
                >
                    {t("general.subscriptions")}
                </List.GroupItem>
            </HasPermissionWrapper>
            <HasPermissionWrapper
                resource="scheduleitemorganizationclasspassgroup"
                permission="view"
            >
                <List.GroupItem
                    key={v4()}
                    className="d-flex align-items-center"
                    to={"#/schedule/classes/all/classpasses/" + classId}
                    icon="credit-card"
                    active={activeLink === "classpasses"}
                >
                    {t("general.classpasses")}
                </List.GroupItem>
            </HasPermissionWrapper>
            {waitlistEnabled && (
                <HasPermissionWrapper
                    resource="scheduleitemattendance"
                    permission="view"
                >
                    <List.GroupItem
                        key={v4()}
                        className="d-flex align-items-center"
                        to={"#/schedule/classes/all/waitlist/" + classId}
                        icon="clock"
                        active={activeLink === "waitlist"}
                    >
                        {t("general.waitlist")}
                    </List.GroupItem>
                </HasPermissionWrapper>
            )}
        </List.Group>
    );
};

export default withTranslation()(ClassEditMenu);
